import { Link } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { SERVICES, FRACTIONAL, CONTACT_EMAIL } from "@/content";

const SERVICE_LINKS = [...SERVICES, FRACTIONAL];

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/outcomes", label: "Outcomes" },
  { to: "/sectors", label: "Sectors" },
  { to: "/about", label: "About" },
  { to: "/growth", label: "Growth Adviser" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-navy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.3fr_0.8fr_1.1fr_0.8fr]">
          <div>
            <Link to="/" className="inline-flex" data-testid="footer-logo" aria-label="Thrive Business Development, home">
              <Logo size="lg" />
            </Link>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
              Strategic business development and market intelligence for energy and technical markets.
            </p>
          </div>

          <nav aria-label="Footer" className="flex flex-col gap-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Navigate</span>
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="w-max text-sm text-slate-400 transition-colors hover:text-gold"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <nav aria-label="Services" className="flex flex-col gap-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Services</span>
            {SERVICE_LINKS.map((s) => (
              <Link
                key={s.id}
                to={`/services#${s.id}`}
                data-testid={`footer-service-${s.id}`}
                className="w-max text-sm text-slate-400 transition-colors hover:text-gold"
              >
                {s.title}
              </Link>
            ))}
          </nav>

          <div className="flex flex-col gap-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Connect</span>
            <a
              href="#"
              data-testid="footer-linkedin-placeholder"
              className="inline-flex w-max items-center gap-2.5 text-sm text-slate-400 transition-colors hover:text-gold"
              title="LinkedIn: link coming soon"
            >
              <Linkedin size={15} className="text-gold/70" /> LinkedIn
            </a>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email-link"
              className="inline-flex w-max items-center gap-2.5 text-sm text-slate-400 transition-colors hover:text-gold"
              title={CONTACT_EMAIL}
            >
              <Mail size={15} className="text-gold/70" /> Email
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] tracking-wider text-slate-500">
            © {new Date().getFullYear()} Thrive Business Development
            <span className="mx-3 text-slate-700" aria-hidden="true">·</span>
            <Link to="/brand" data-testid="footer-brand-assets-link" className="transition-colors hover:text-gold">
              Brand assets
            </Link>
          </p>
          <p className="font-mono text-[11px] tracking-wider text-slate-600">
            Intelligence-led growth for technical markets
          </p>
        </div>
      </div>
    </footer>
  );
}
